<template>
  <v-container fluid grid-list-xl fill-height>
    <v-layout row align-center>
      <v-flex xs12 md4 offset-md4>
        <v-card>
          <v-toolbar
            dark
            color="secondary"
            tabs
          >
            <v-toolbar-side-icon>
              <img
                height="38"
                src="@/assets/images/tarsius-next-logo-head-pink-52.png"
              />
            </v-toolbar-side-icon>
            <v-toolbar-title>Tarsius Next</v-toolbar-title>
            <v-tabs
              v-model="tabs"
              color="secondary"
              slot="extension"
              slider-color="accent"
              centered
              grow
            >
              <v-tab
                href="#tab-login"
                ripple
              >
                {{$t('auth.login')}}
              </v-tab>
              <v-tab
                href="#tab-register"
                ripple
              >
                {{$t('auth.register')}}
              </v-tab>
            </v-tabs>
          </v-toolbar>

          <v-card-text>
            <v-tabs-items v-model="tabs">
              <v-tab-item value="tab-login">
                <v-flex xs12>
                  <v-text-field
                    v-model="loginEmail"
                    name="email"
                    type="email"
                    :label="$t('auth.email')"
                    prepend-icon="mail"
                    @keyup.enter="login"
                    required
                    autofocus
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="loginPassword"
                    name="password"
                    :append-icon="hideLoginPassword ? 'visibility' : 'visibility_off'"
                    :type="hideLoginPassword ? 'password' : 'text'"
                    :label="$t('auth.password')"
                    prepend-icon="lock"
                    @keyup.enter="login"
                    @click:append="hideLoginPassword = !hideLoginPassword"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 text-xs-left>
                  <a
                    @click="resetPasswordDialogVisible = true"
                  >Forgot password?</a>
                </v-flex>
                <v-flex xs12 text-xs-right>
                  <v-btn
                    color="accent"
                    type="submit"
                    @click="login"
                    block
                    large
                  >
                    {{ $t("auth.login") }}
                  </v-btn>
                </v-flex>
              </v-tab-item>
              <v-tab-item value="tab-register">
                <v-flex xs12>
                  <v-text-field
                    v-model="registerName"
                    name="username"
                    type="text"
                    :label="$t('auth.username')"
                    prepend-icon="person"
                    required
                    autofocus
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="registerEmail"
                    name="email"
                    type="email"
                    :label="$t('auth.email')"
                    prepend-icon="mail"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="registerPassword"
                    name="password"
                    :append-icon="hideRegisterPassword ? 'visibility' : 'visibility_off'"
                    :type="hideRegisterPassword ? 'password' : 'text'"
                    :label="$t('auth.password')"
                    @click:append="hideRegisterPassword = !hideRegisterPassword"
                    prepend-icon="lock"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="registerPasswordConfirmation"
                    name="password_confirmation"
                    :append-icon="hideRegisterConfirmPassword ? 'visibility' : 'visibility_off'"
                    :type="hideRegisterConfirmPassword ? 'password' : 'text'"
                    :label="$t('auth.confirmPassword')"
                    prepend-icon="lock"
                    @click:append="hideRegisterConfirmPassword = !hideRegisterConfirmPassword"
                    @keyup.enter="register"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 text-xs-right>
                  <v-btn
                    color="accent"
                    type="submit"
                    @click="register"
                    block
                    large
                  >
                    {{ $t("auth.register") }}
                  </v-btn>
                </v-flex>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="resetPasswordDialogVisible"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline primary white--text"
          primary-title
        >
          Reset password
        </v-card-title>

        <v-card-text>
          <p>
            Please enter your email address to reset your password.
            You'll receive link to reset your password on your email after clicking send button.
          </p>

          <v-text-field
            v-model="resetPasswordEmail"
            name="email"
            type="email"
            :label="$t('auth.email')"
            prepend-icon="mail"
          ></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="resetPassword()"
          >
            Send
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios';
import { AUTH_REQUEST, AUTH_REGISTER } from '@/store/actions/auth';

export default {
  name: 'login',
  data() {
    return {
      loginEmail: null,
      loginPassword: null,
      registerName: null,
      registerEmail: null,
      registerPassword: null,
      registerPasswordConfirmation: null,
      resetPasswordEmail: null,
      hideLoginPassword: true,
      hideRegisterPassword: true,
      hideRegisterConfirmPassword: true,
      resetPasswordDialogVisible: false,
      tabs: null,
      apiUrl: window.api_url,
    };
  },
  methods: {
    login() {
      const payload = {
        email: this.loginEmail,
        password: this.loginPassword,
        vm: this,
      };

      this.$toasted.show('Logging in...', { singleton: true, type: 'info' });

      this.$store.dispatch(AUTH_REQUEST, payload).then(() => {
        this.$router.push('/home');
        this.$toasted.clear();
      });
    },
    register() {
      const vm = this;
      const registerDetails = {
        name: this.registerName,
        email: this.registerEmail,
        password: this.registerPassword,
        password_confirmation: this.registerPasswordConfirmation,
      };
      // const loginDetails = {
      //   email: this.registerEmail,
      //   password: this.registerPassword,
      // };

      this.$store.dispatch(AUTH_REGISTER, registerDetails).then((response) => {
        vm.$toasted.show(response.data.message, { singleton: true, type: 'success' });

        // Don't redirect, we need to verify email address first
        //
        // this.$store.dispatch(AUTH_REQUEST, loginDetails).then(() => {
        //   this.$router.push('/home');
        //   this.$toasted.clear();
        // });
      });
    },
    resetPassword() {
      const vm = this;

      this.resetPasswordDialogVisible = false;

      axios.post(`${this.apiUrl}api/password/email`, {
        email: this.resetPasswordEmail,
      })
        .then((response) => {
          vm.$toasted.show(response.data.message, { duration: 3000, singleton: true, type: 'success' });
        })
        .catch((error) => {
          vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
        });
    },
  },
};
</script>

<style scoped>

</style>
